// src/mobile/event-manager.ts
import { MobileEventActionData, type NavigationEventType } from './types';
import { safeInvoke } from '../../../utils/function';
import { registerSpecificNotificationHandler } from '../../../bridge';
import { NativeAPIResponseMessage } from '@zoom/hybrid-jsbridge';

type CallbackRegistry = Map<string, (data: unknown) => void>;

export class EventManager {
  private static instance: EventManager;
  private callbacks: Map<NavigationEventType, CallbackRegistry> = new Map();

  private constructor() {}

  static getInstance(): EventManager {
    if (!EventManager.instance) {
      EventManager.instance = new EventManager();
    }
    return EventManager.instance;
  }

  registerCallback(
    eventType: NavigationEventType,
    actionID: string,
    callback: () => void
  ): void {
    console.log('registerCallback', eventType, actionID, eventType);
    if (!this.callbacks.has(eventType)) {
      this.callbacks.set(eventType, new Map());
    }
    this.callbacks.get(eventType)?.set(actionID, callback);
  }

  unregisterCallback(eventType: NavigationEventType, actionID: string): void {
    this.callbacks.get(eventType)?.delete(actionID);
  }

  triggerCallback(
    eventType: NavigationEventType,
    actionID: string,
    payload: any
  ): void {
    const callback = this.callbacks.get(eventType)?.get(actionID);
    if (callback) {
      console.log('triggerCallback', eventType, actionID, payload, callback);
      safeInvoke(callback, { ...payload, actionID });
    } else {
      console.log(`no found callback for ${eventType} ${actionID}`);
    }
  }
}

let eventInited = false;
export function setupEventListenersIfNeeded() {
  if (!eventInited) {
    // Initialize native event listeners
    registerSpecificNotificationHandler(
      ['UnifyNotify_OnMobileUIAction'],
      (notification: NativeAPIResponseMessage<MobileEventActionData>) => {
        const {
          result: { eventType, actionID, data },
        } = notification;
        console.log('notification', notification, eventType, actionID, data);
        EventManager.getInstance().triggerCallback(
          eventType as NavigationEventType,
          actionID,
          data
        );
      }
    );
    eventInited = true;
  }
}
